<template>
  <div class="earring">
    <v-select v-model="properties[`orecchino_${props.position}_forma_id`]" :items="baseData.lookup.orecchino_forma"
        label="Forma" item-title="label" hide-details class="" @update:model-value="updatedForma" />
    <template v-if="showExtended">
      <v-select v-model="properties[`orecchino_${props.position}_colore_id`]" :items="baseData.lookup.orecchino_colore"
          label="Colore" item-title="label" hide-details class="mt-0 earring-extra" />
      <v-select v-model="properties[`orecchino_${props.position}_numsim_id`]" :items="baseData.lookup.orecchino_numsim"
          label="Numero / Simbolo" item-title="label" hide-details class="mt-0 earring-extra" />
    </template>
  </div>
</template>
<script setup>

import { computed, onMounted } from "vue";
import baseData from '@/assets/catalog/TrackerForms.json'

const properties = defineModel("properties")

const props = defineProps(["position",])

onMounted(() => {
})

const showExtended = computed(() => {
  return [3, 4].includes(properties.value[`orecchino_${props.position}_forma_id`])
})


const updatedForma = () => {
  if (! showExtended.value ) {
    properties.value[`orecchino_${props.position}_colore_id`] = 1
    properties.value[`orecchino_${props.position}_numsim_id`] = 1
  }
}

</script>

<style scoped>
.earring{
  border: 5px solid #0001;
}

.earring-extra{
  border-top: 5px solid #0001;
}
</style>
